import { useState, useEffect } from 'react';

function useLocalStorage(key, initialValue) {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = window.localStorage.getItem(key);
      return item ? item : initialValue;
    } catch (error) {
      console.log(error);
      return initialValue;
    }
  });

  useEffect(() => {
    try {
      if (storedValue === undefined) {
        window.localStorage.removeItem(key);
      } else {
        window.localStorage.setItem(key, storedValue);
      }
    } catch (error) {
      console.log(error);
    }
  }, [key, storedValue]);

  const clearStoredValue = () => {
    setStoredValue(undefined);
  };

  return [storedValue, setStoredValue, clearStoredValue];
}

export default useLocalStorage;
